import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Layout from "components/Layout";
import { Hooks, Util } from "@xt/xtbase";
const { useDocumentWidth } = Hooks;
import Topimg from "@/assets/images/academy/topimg.png";
import Topimgs from "@/assets/images/academy/topimgs.png";
import Mage from "@/assets/images/academy/mage.png";
import Mage2 from "@/assets/images/academy/mage2.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  const isMobile = (useDocumentWidth() ?? 0) <= 768;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.learnCrypto, className)}>
        <div className={cx(styles.topImage, className)} style={{ backgroundImage: `url(${isMobile ? Topimgs : Topimg})` }}></div>
        <div className={cx(styles.article, className)}>
          <div className={cx(styles.articlecontent, className)}>
            <div className={cx(styles.graphbox, className)}>
              <h5 className={cx(styles.graph, className)}>
                Whether you've already got some cryptocurrency knowledge, or you're just curious as to what the hype is about crypto, Sigma Academy is here for you.
              </h5>
              <h5 className={cx(styles.graph, className)}>
                For those who are new to crypto, more questions than answers may arise when you start your crypto knowledge journey, but be rest assured, it
                does become clearer as you progress. Our tutorials and content will explain it every step of the way. The world of crypto is fast evolving with
                new currencies popping up and changes to the regulatory landscape. It is Sigma Academy's mission to equip you with the knowledge and understanding
                of all things crypto. Enabling you to buy and trade with confidence and with trust that SIGMA will support you every step of the way. From
                understanding how blockchain works, the acronyms you'll come across, and the jargon you might not have heard of, we've got it here.
              </h5>
              <h5 className={cx(styles.graph, className)}>
                Our tutorials and content have been structured in a progressive way (beginner, intermediate, and advanced) to ensure you have the prerequisite
                understanding and knowledge of how this industry works and how you can get involved.
              </h5>
              <h5 className={cx(styles.graph, className)}>
                To get started on SIGMA, remember to sign up and follow us on our socials to get the latest updates, content, and news.
              </h5>
            </div>
            <div className={cx(styles.magebox, className)}>
              <img src={isMobile ? Mage2 : Mage} />
            </div>
          </div>

          <ul>
            <li id="academy0">
              <div>
                <h2>what is Cryptocurrency?</h2>
                <h4>Let's get started with the most obvious question, what is Cryptocurrency and why are so many people talking about it?</h4>
                <h4>
                  A Cryptocurrency, (also known as crypto) is a virtual or digital currency which uses cryptography (hence the crypto part) to secure the
                  integrity of the currency. Just like the cash in your wallet, you can use crypto to make purchases or add it to your investment portfolio. The
                  validation of a crypto exchange is secured using what's called Blockchain Technology, a ledger which verifies and enables the transaction to
                  occur. With Blockchain technology, cryptocurrency transfers can be made secure and without the need of an intermediary body, like a bank or
                  government. The more traditional online payment methods are owned by organisations which usually require you to first transfer the money to
                  them, then they transfer the money on your behalf when you make a payment. As we mentioned before, there isn't a middle man in the process.
                  Instead, there's a whole web of computers verifying and processing the transaction.
                </h4>
              </div>
            </li>
            <li id="academy1">
              <div>
                <h2>So what's the difference with normal currency?</h2>
                <h4>
                  Many of you might be wondering, what's wrong with the USD, or the Euro? What can Cryptocurrency do that the cash in my wallet can't do? These
                  are very valid questions and being able to distinguish the difference will help you better appreciate why cryptocurrencies have been gaining
                  such popularity. Cryptocurrencies can be purchased, sold, earnt, won, and exchanged just like you can with fiat currencies (non-digital,
                  government backed currency that you have in your wallet). However, the platform is decentralised and unlike fiat currencies, is not government
                  backed or valued against commodities such as gold. Since it isn't government backed, it means that cryptocurrencies are mostly immune to
                  influences such as inflation or economic turmoil. Furthermore, cryptocurrency is effectively an international currency. Once you have some
                  crypto, you could circumvent the fees and hassle associated with international currency conversion.
                </h4>
                <h4>
                  Indeed, there are some elements of the crypto world which are still in their infancy, and the regulatory environment still needs to catch up,
                  but the list of institutions and governments accepting crypto is ever growing, meaning a future with crypto in some way, shape, or form, is
                  inevitable. Might as well get some crypto now right?
                </h4>
              </div>
            </li>
            <li id="academy2">
              <div>
                <h2>We can't talk about Cryptocurrency without talking about Bitcoin</h2>
                <h4>
                  When you hear about cryptocurrency, the first thing that will probably come to your mind is Bitcoin. Bitcoin has been a trailblazer in the
                  crypto world. Turning crypto from a mere concept, into a mainstream investment option. Since being launched back in 2009, Bitcoin proved the
                  viability and credibility a digital currency can be. Paired with Blockchain technology, Bitcoin demonstrated that a digital currency is not
                  only viable, but revolutionary in the world of finance.
                </h4>
              </div>
            </li>
            <li id="academy3">
              <div>
                <h2>So who started Bitcoin you might ask</h2>
                <h4>
                  Blockchain Technology is a digital recording mechanism which is connected to a network of computers. This technology enables transactions to
                  take place without the need of an intermediary such as a bank, government, or third party. To secure the integrity and security of the
                  process, a digital ledger records the list of transactions using blocks which are linked together (hence, blockchain). This system is
                  append-only, meaning that information can only be added to the system, not deleted. Once some information has been recorded in a block, it
                  becomes very difficult to alter or tamper the information, as the information becomes interconnected with other blocks in the sequence. If the
                  data in one block gets tampered with, it would therefore alter the subsequent block, deeming it invalid and alerting the system. Another
                  important feature Blockchain provides is its ability to prevent double spending of a given digital currency. For example, we can easily share
                  and exchange pictures and videos between friends online, effectively duplicating the original content. This is easy to do in the online world,
                  but also provides a challenge to cryptocurrency as duplication would effectively devalue and illegitimise the currency. This is where
                  Blockchain Technology comes in. It prevents the possibility of double spending via cryptography.
                </h4>
              </div>
            </li>
            <li>
              <div>
                <h2>What is this Blockchain Technology I keep hearing about?</h2>
                <h4>
                  Blockchain Technology is a digital recording mechanism which is connected to a network of computers. This technology enables transactions to
                  take place without the need of an intermediary such as a bank, government, or third party. To secure the integrity and security of the
                  process, a digital ledger records the list of transactions using blocks which are linked together (hence, blockchain). This system is
                  append-only, meaning that information can only be added to the system, not deleted. Once some information has been recorded in a block, it
                  becomes very difficult to alter or tamper the information, as the information becomes interconnected with other blocks in the sequence. If the
                  data in one block gets tampered with, it would therefore alter the subsequent block, deeming it invalid and alerting the system. Another
                  important feature Blockchain provides is its ability to prevent double spending of a given digital currency. For example, we can easily share
                  and exchange pictures and videos between friends online, effectively duplicating the original content. This is easy to do in the online world,
                  but also provides a challenge to cryptocurrency as duplication would effectively devalue and illegitimise the currency. This is where
                  Blockchain Technology comes in. It prevents the possibility of double spending via cryptography.{" "}
                </h4>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
